module.exports = __webpack_public_path__ + "static/media/print1.ff146bd1.jpg";